"use client";
import "./honey.css";
import Image from "next/image";

const columns = [3, 4, 4, 3];
const TOTAL_HEX = columns.reduce((a, b) => a + b, 0);

export default function HoneyCombGallery({ data = [] }) {
  const filledData = [...data];

  while (filledData.length < TOTAL_HEX) {
    filledData.push(null);
  }
  let index = 0;

  return (
    <div className="honeycomb">
      {columns.map((count, colIndex) => (
        <div key={colIndex} className={`column col-${colIndex}`}>
          {Array.from({ length: count }).map((_, i) => {
            const item = filledData[index++];
            const hexKey = item?.name ? `${item.name}-${colIndex}-${i}` : `empty-${colIndex}-${i}`;

            return (
              <div className="hex" key={hexKey}>
                <div className="hex-inner">
                  {item ? (
                    <div className="flex justify-center items-center w-full h-full">
                      <div className="relative w-full h-full min-h-[80px]">
                        <Image
                          src={item.image}
                          alt={item.alt || item.title || "Technology logo"}
                          fill
                          className={`object-contain object-center ${item.darkImage ? "dark:hidden" : ""}`}
                          sizes="(max-width: 768px) 80px, 120px"
                        />
                        {item.darkImage && (
                          <Image
                            src={item.darkImage}
                            alt={item.alt || item.title || "Technology logo"}
                            fill
                            className="object-contain object-center hidden dark:block"
                            sizes="(max-width: 768px) 80px, 120px"
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="w-[60px] h-[60px]" />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
